<script setup>
  import { reactive, ref } from 'vue';
  import axios from 'axios';
  import CardJoin from "./CardJoin.vue";

  const props = defineProps({
    model: Object
  });

  const form = reactive({
    area: '',
    name: '',
    number_phone: '',
    email: '',
    address: '',
    postal_code: '',
    city: '',
    message: '',
    files: [],
    checkbox: false
  });

  const loading = ref(false);
  const successMessage = ref('');
  const errorMessage = ref('');

  const handleSelectOpportunity = (areaTitle) => {
    form.area = areaTitle;

    const formElement = document.querySelector('.formulario');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleFileUpload = (event) => {
    form.files = Array.from(event.target.files);
  };

  const handleClear = () => {
    form.area = '';
    form.name = '';
    form.number_phone = '';
    form.email = '';
    form.address = '';
    form.postal_code = '';
    form.city = '';
    form.message = '';
    form.files = [];
    form.checkbox = false;
    successMessage.value = '';
    errorMessage.value = '';
  };

  const handleSubmit = async () => {
    loading.value = true;
    successMessage.value = '';
    errorMessage.value = '';

    const formData = new FormData();
    formData.append('area', form.area);
    formData.append('name', form.name);
    formData.append('number_phone', form.number_phone);
    formData.append('email', form.email);
    formData.append('address', form.address);
    formData.append('postal_code', form.postal_code);
    formData.append('city', form.city);
    formData.append('message', form.message);
    formData.append('checkbox', form.checkbox ? '1' : '');

    form.files.forEach((file) => {
      formData.append('files[]', file);
    });

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

    try {
      const response = await axios.post('/candidatura-form', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept': 'application/json',
          'X-CSRF-TOKEN': csrfToken
        }
      });

      successMessage.value = response.data.message || 'Obrigada pela sua candidatura!';
      handleClear();
    } catch (error) {
      if (error.response && error.response.status === 422) {
        errorMessage.value = 'Erro de validação. Verifique se preencheu todos os campos corretamente e anexou um documento válido.';
      } else {
        errorMessage.value = 'Ocorreu um erro ao enviar. Tente novamente.';
      }
    } finally {
      loading.value = false;
    }
  };
</script>

<template>
  <div class="container-joins">
    <div class="container">
      <div class="content-candidaturas">
        <div class="candidatura-espontanea">
          <h3>Speculative Cover Letter</h3>
          <!-- Mensagem de Sucesso -->
          <div v-if="successMessage" class="alert alert-success" role="alert">
            {{ successMessage }}
          </div>

          <!-- Mensagem de Erro -->
          <div v-if="errorMessage" class="alert alert-danger" role="alert">
            {{ errorMessage }}
          </div>
          <div class="formulario">
            <form @submit.prevent="handleSubmit">
              <div class="form-group">
                <label for="inputState-desktop">Area you are applying for</label>
                <select id="inputState-desktop" v-model="form.area" class="form-control" name="area">
                  <option value="" disabled selected>Select an area (optional)</option>
                  <option
                    v-for="article in model.paginatedArticles['articles']"
                    :key="article.id || article.title"
                    :value="article.title">
                    {{ article.title }}
                  </option>
                </select>
              </div>

              <!-- Name -->
              <div class="form-group">
                <input type="text" v-model="form.name" required class="form-control" placeholder="Name" />
              </div>

              <!-- Number Phone -->
              <div class="form-group">
                <input type="tel" v-model="form.number_phone" required class="form-control" placeholder="Contact number (e.g. 912345678)" />
              </div>

              <!-- Email -->
              <div class="form-group">
                <input type="email" v-model="form.email" required class="form-control" placeholder="E-mail" />
              </div>

              <!-- Address -->
              <div class="form-group">
                <input type="text" v-model="form.address" required class="form-control" placeholder="Address" />
              </div>

              <!-- Postal Code & City -->
              <div class="div-input">
                <div class="form-group">
                  <input type="text" v-model="form.postal_code" required class="form-control" placeholder="Postal Code (e.g. 1234-567)" />
                </div>
                <div class="form-group">
                  <input type="text" v-model="form.city" required class="form-control" placeholder="Locality" />
                </div>
              </div>

              <!-- Message -->
              <div class="form-group">
                <textarea v-model="form.message" rows="4" required class="form-control" placeholder="Message"></textarea>
              </div>

              <!-- File Upload -->
              <div class="input-docs form-group">
                <input
                  type="file"
                  class="form-control"
                  accept=".pdf,.doc,.docx"
                  multiple
                  required
                  @change="handleFileUpload"
                />
              </div>
              <!-- Checkbox (Terms) -->
              <div class="form-group checkbox-group">
                <label>
                  <input type="checkbox" v-model="form.checkbox" required />
                  Authorise the use and processing of my data
                </label>
              </div>
              <div class="form-actions">
                <button type="button" @click="handleClear" class="btn-clear" :disabled="loading">Clear</button>
                <button type="submit" class="btn-submit" :disabled="loading">
                  <span v-if="loading">Sending...</span>
                  <span v-else>Send</span>
                </button>
              </div>
            </form>
          </div>
        </div>
        <div class="vagas">
          <h3>Available opportunities</h3>
          <div class="content-vagas" v-if="model.paginatedArticles['articles']">
            <card-join
              :item="model.paginatedArticles['articles']"
              @apply="handleSelectOpportunity"
            />
          </div>
          <div v-else class="content-no-vagas">
            <p>There are no applications available.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  .alert {
    padding: 12px 16px;
    margin-bottom: 20px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
  }

  .alert-success {
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
  }

  .alert-danger {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
  }
</style>
